import { clone } from 'lodash';

import { User } from '../users/user';
import { Organization } from '../organizations/organization';
import { PunchCard } from './punch-card';
import { Resource } from '../shared/resource';

const camelcaseKeysDeep = require('camelcase-keys-deep');

export class PunchCardDecision extends Resource {
  id: string;
  punchcard: PunchCard;
  organization: Organization;
  decidedBy: User;
  decidedAt: string;
  decisionStatus: string;
  notes: string;
  loading = false;

  url(action): string {
    return '/punchcards/' + this.id + '/decisions/' + action;
  }

  filterOptions(options): any[] {
    options = clone(options);

    return options;
  }
}
